export const PRX_SALES_REP_LABEL = 'PRX Sales Rep';

/**
 * POM-6494: the order partner's current internal Sales User. An unassigned partner reads
 * "Not assigned"; undefined means the order has not loaded it yet.
 */
const formatPrxSalesRep = (prxSalesRep) => {
  if (prxSalesRep === undefined) {
    return undefined;
  }

  return prxSalesRep ? `${prxSalesRep.firstName} ${prxSalesRep.lastName}` : 'Not assigned';
};

export default formatPrxSalesRep;
